var dispatcher = require("../dispatcher");
var constants = require("../constants/constants");
var axios = require('axios');
var EventEmitter = require('events').EventEmitter;
var em = new EventEmitter();

function LoginStore() {
    var listeners = [];
    var tempSession = {};


    function addListener(eventName, callback) {
        em.addListener(eventName, callback);
    }

    function removeListener(eventName, callback) {
        em.removeListener(eventName, callback);
    }

    function getLoginDetails() {
        return tempSession;
    }

    function onChange(listener) {
        listeners.push(listener);
    }
    function saveLogin(loginInfo) {
        axios.post(constants.config.HOST + constants.api.POST_LOGIN, {
            Mobile: loginInfo.userName,
            Password: loginInfo.password
        })
            .then(function (response) {        
                tempSession = (response.data);
                sessionStorage.setItem("User", JSON.stringify(tempSession));
                em.emit('getloginDetails');
                console.log(JSON.parse(sessionStorage.getItem("User")));
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    dispatcher.register(function (payload) {
        var split = payload.type.split(":");
        if (split[0] === "login") {
            switch (split[1]) {
                case "saveLogin":
                    saveLogin(payload.loginInfo);
                    break;

            }
        }
    });
    return {
        onChange: onChange,
        addListener: addListener,
        removeListener: removeListener,
        getLoginDetails: getLoginDetails
    }
}
module.exports = LoginStore();


// WEBPACK FOOTER //
// ./src/stores/LoginStore.js